import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { injectModels } from "../../redux/injectModels";
import { EventService } from "../../services";
import { useParams } from "react-router-dom";
import ImagePreview from "../../components/Image/ImagePreview";
import EventModel from "../../components/Model/EventModel";
import { formatDateENGB, handleConsoleError } from "../../utils/common-methods";
import PreWithCopy from "../../components/Common/PreWithCopy";
import { toast } from "react-toastify";
const EventDetail = (props) => {
  const [eventData, setEventData] = useState({ ...EventModel });
  const [showParkingInstructions, setShowParkingInstructions] = useState(false);
  const [showHealthSafetyGuidelines, setShowHealthSafetyGuidelines] = useState(
    false
  );
  const text = `<a 
  href="${process.env.REACT_APP_HOME_URL}/events/${eventData?.url}" 
  target="_blank" 
  rel="noopener noreferrer">
  
  <img 
    style="height: 60px;" 
    src="${process.env.REACT_APP_HOME_URL}/assets/images/logo-swallow.jpg" 
    alt="GWCT Logo" />
</a>`;

  const { eventId } = useParams();
  const getData = async () => {
    try {
      if (eventId && eventId.length > 5) {
        props.application.setLoading(true);
        const eventData = await EventService.getEventById(eventId);
        const eventMappedData = { ...EventModel, ...eventData?.data };
        setEventData(eventMappedData);
        // if (eventMappedData && eventMappedData.id?.length > 2) {
        //   EventService.setSelectedEvent({
        //     id: eventMappedData.id,
        //     name: eventMappedData.eventName,
        //     status: eventMappedData.eventStatusId,
        //   });
        // } else {
        //   EventService.removeSelectedEvent();
        // }
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const convertTo12HourFormat = (time) => {
    const [hours, minutes, seconds] = time?.split(":").map(Number);

    // Create a new date object (set to a dummy date, like 1st Jan 1970)
    const date = new Date();
    date.setHours(hours, minutes, seconds);

    // Get the hours and minutes in 12-hour format
    let hours12 = date.getHours() % 12 || 12; // Get hours in 12-hour format
    let minutesVal = date
      .getMinutes()
      .toString()
      .padStart(2, "0");
    let ampm = date.getHours() >= 12 ? "PM" : "AM"; // Determine AM/PM

    return `${hours12}:${minutesVal} ${ampm}`;
  };

  const ParkingInstructions = eventData?.parkinginstructions || "";
  const displayParkingInstructions =
    ParkingInstructions?.length > 800 && !showParkingInstructions
      ? `${ParkingInstructions.substring(
          0,
          800
        )} <a href="#!" class="toggle-text">show more...</a>`
      : ParkingInstructions?.length < 800
      ? ParkingInstructions
      : `${ParkingInstructions} <a href="#!" class="toggle-text">show less</a>`;
  const HealthSafetyGuideline = eventData?.healthSafetyInfo || "";
  const displayHealthSafetyGuideline =
    HealthSafetyGuideline?.length > 800 && !showHealthSafetyGuidelines
      ? `${HealthSafetyGuideline.substring(
          0,
          800
        )} <a href="#!" class="toggle-text">show more...</a>`
      : HealthSafetyGuideline.length < 800
      ? HealthSafetyGuideline
      : `${HealthSafetyGuideline} <a href="#!" class="toggle-text">show less</a>`;

  useEffect(() => {
    getData();
  }, []);
  return (
    <React.Fragment>
      <div className="container mt-3">
        <React.Fragment>
          {" "}
          <h3
            style={{
              background: "#8a8a8a",
              borderRadius: "10px 10px 0px 0px",
              padding: "10px",
              color: "#ffffff",
              marginBottom: "0px",
            }}
            className=""
          >
            General Info
          </h3>
          <section className="edit-form-table">
            <div className="">
              <div className="table-responsive">
                <Table striped bordered hover>
                  <tbody>
                    <tr>
                      <td>Event Name</td>
                      <td>{eventData?.eventName}</td>
                    </tr>
                    <tr>
                      <td>Event Type</td>
                      <td>{eventData?.eventCategoryTypeName}</td>
                    </tr>
                    <tr>
                      <td>Event Status</td>
                      <td>{eventData?.eventStatusName}</td>
                    </tr>
                    <tr>
                      <td>Description</td>
                      {/* <td>{eventData?.eventDescription}</td> */}
                      <td>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: eventData?.eventDescription,
                          }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </section>
        </React.Fragment>
        <React.Fragment>
          {" "}
          <h3
            style={{
              background: "#8a8a8a",
              borderRadius: "10px 10px 0px 0px",
              padding: "10px",
              color: "#ffffff",
              marginBottom: "0px",
            }}
            className=""
          >
            Location
          </h3>
          <section className="edit-form-table">
            <div className="">
              <div className="table-responsive">
                <Table striped bordered hover>
                  <tbody>
                    <tr>
                      <td>Address</td>
                      <td>
                        {[
                          eventData?.street1,
                          eventData?.street2,
                          eventData?.city,
                          eventData?.stateName,
                          eventData?.countryName,
                          eventData?.zip,
                        ]
                          .filter(Boolean) // Removes null, undefined, and empty strings
                          .join(", ")}
                      </td>
                    </tr>
                    <tr>
                      <td>Start </td>
                      <td>
                        {(eventData.startDate
                          ? formatDateENGB(eventData?.startDate)
                          : "") +
                          " " +
                          (eventData.startTime
                            ? "at " + convertTo12HourFormat(eventData?.startTime)
                            : "")}
                      </td>
                    </tr>
                    <tr>
                      <td>End</td>
                      <td>
                        {(eventData?.endDate
                          ? formatDateENGB(eventData?.endDate)
                          : "") +
                          " " +
                          (eventData?.endTime
                            ? "at " + convertTo12HourFormat(eventData?.endTime)
                            : "")}
                      </td>
                    </tr>
                    {/* <tr>
                      <td>Timezone</td>
                      <td>{eventData?.timezoneName}</td>
                    </tr> */}
                  </tbody>
                </Table>
              </div>
            </div>
          </section>
        </React.Fragment>

        <React.Fragment>
          {" "}
          <h3
            style={{
              background: "#8a8a8a",
              borderRadius: "10px 10px 0px 0px",
              padding: "10px",
              color: "#ffffff",
              marginBottom: "0px",
            }}
            className=""
          >
            Cover Pictures
          </h3>
          <section className="edit-form-table">
            <div
              className="row justify-content-center"
              style={{ marginTop: "20px" }}
            >
              <div className="col-lg-6 col-sm-12">
                <div className="Pictures-add">
                  <div
                    className="Pictures-add1"
                    style={{ textAlign: "center", marginBottom: "20px" }}
                  >
                    <h6>Wide view</h6>
                    <ImagePreview
                      src={eventData?.coverPicWideUrl}
                      width="300px"
                      height="200px"
                      style={{
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        display: "block",
                        margin: "0 auto",
                      }}
                    />
                  </div>

                  <div
                    className="Pictures-add1"
                    style={{ textAlign: "center" }}
                  >
                    <h6>Square view</h6>
                    <ImagePreview
                      src={eventData?.coverPicSquareUrl}
                      width="200px"
                      height="200px"
                      style={{
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        display: "block",
                        margin: "0 auto",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </React.Fragment>

        <React.Fragment>
          {" "}
          <h3
            style={{
              background: "#8a8a8a",
              borderRadius: "10px 10px 0px 0px",
              padding: "10px",
              color: "#ffffff",
              marginBottom: "0px",
            }}
            className=""
          >
            Instructions and Guidelines
          </h3>
          <section className="edit-form-table">
            <div className="">
              <div className="table-responsive">
                <Table striped bordered hover>
                  <tbody>
                    <tr>
                      <td>Parking Instructions</td>
                      <td>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: displayParkingInstructions,
                          }}
                          onClick={(e) => {
                            if (e.target.className === "toggle-text") {
                              e.preventDefault();
                              setShowParkingInstructions((prev) => !prev);
                            }
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Health & Safety Guidelines</td>
                      <td>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: displayHealthSafetyGuideline,
                          }}
                          onClick={(e) => {
                            if (e.target.className === "toggle-text") {
                              e.preventDefault();
                              setShowHealthSafetyGuidelines((prev) => !prev);
                            }
                          }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </section>
        </React.Fragment>

        <React.Fragment>
          {" "}
          <h3
            style={{
              background: "#8a8a8a",
              borderRadius: "10px 10px 0px 0px",
              padding: "10px",
              color: "#ffffff",
              marginBottom: "0px",
            }}
            className=""
          >
            Direct HTML Contact From Link (Add this to your event website for
            seamless application integration)
          </h3>
          <section className="edit-form-table">
            <div className="">
              <div className="table-responsive">
                <PreWithCopy text={text} />
              </div>
            </div>
          </section>
        </React.Fragment>
      </div>
    </React.Fragment>
  );
};

export default injectModels(["application"])(EventDetail);
